(function () {
  'use strict';

  angular.module('autofocus', []);
})();
